import React, { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { useNewUser } from "../../APIContext/NewUserContext";
import validations from "../../Config/validations";
import Swal from "sweetalert2";

// import "./AddChild.css";

/* ---------- Dropdown Data ---------- */

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const gradeList = [
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "1st", value: "1st" },
  { label: "2nd", value: "2nd" },
  { label: "3rd", value: "3rd" },
  { label: "4th", value: "4th" },
  { label: "5th", value: "5th" },
  { label: "6th", value: "6th" },
  { label: "7th", value: "7th" },
  { label: "8th", value: "8th" },
  { label: "High School", value: "High School" },
  { label: "College", value: "College" },
  { label: "Professional", value: "Professional" },
];

const genderList = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

/* ---------- Mock Existing Children (replace with API) ---------- */
const existingChildren = [
  { id: 1, name: "John Doe" },
  { id: 2, name: "Emily Paul" },
];

export const UserView = ({ packageID }) => {
  const { addToCart, fetchPlayer } = useNewUser();
  const [mode, setMode] = useState("create");
  const [childData, setChildData] = useState([]);
  const [selectedChild, setSelectedChild] = useState("");

  const [selectedChildId, setSelectedChildId] = useState("");
  const [selectedChildData, setSelectedChildData] = useState(null);
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    date_of_birth: "",
    grade: "",
    jersey_size: "",
    school_name: "",
  });

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await fetchPlayer();
        setChildData(data);
      } catch (err) {
        console.log(err);
      }
    };
    fetch();
  }, []);

  // console.log(childData)

  const handleSelectChild = (e) => {
    const childId = e.target.value;
    setSelectedChildId(childId);
    setMode("select");

    const child = childData.find((item) => String(item.id) === String(childId));

    if (!child) return;
    const fullName = child.name?.trim() || "";
    const nameParts = fullName.split(" ");

    const first_name = nameParts[0] || "";
    const last_name = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
    setSelectedChildData({
      id: child.id,
      first_name,
      last_name,
      date_of_birth: child.date_of_birth,
      gender: child.gender,
      grade: child.grade,
      school_name: child.school_name,
      jersey_size: child.jersey_size,
    });
  };

  const handleDateChange = (e) => {
    const dob = e.value;
    if (!dob) return;

    const today = new Date();
    const age =
      today.getFullYear() -
      dob.getFullYear() -
      (today.getMonth() < dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
        ? 1
        : 0);

    const year = dob.getFullYear();
    const month = String(dob.getMonth() + 1).padStart(2, "0");
    const day = String(dob.getDate()).padStart(2, "0");

    const formattedDOB = `${year}-${month}-${day}`;

    setFormData((prev) => ({
      ...prev,
      date_of_birth: formattedDOB,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const missingFields = validations(
      {
        first_name: "First Name",
        last_name: "Last Name",
        gender: "Gender",
        date_of_birth: "Date of Birth",
        grade: "Grade",
        jersey_size: "Jersey Size",
        school_name: "School Name",
      },
      formData,
    );

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: `Missing Fields`,
        text: `Please enter: ${missingFields.join(", ")}`,
        confirmButtonColor: "#B79527",
      });
      return;
    }
    let payload;
    if (mode === "create") {
      payload = {
        package_ids: [Number(packageID)],
        player: formData,
      };
      addToCart(payload);
    } else {
      payload = {
        package_ids: [Number(packageID)],
        player_id: Number(selectedChildData.id),
      };
      addToCart(payload);
    }
  };

  return (
    <>
      <div className="child-toggle">
        <button
          className={`toggle-btn ${mode === "create" ? "active" : ""}`}
          onClick={() => setMode("create")}
        >
          Create Child
        </button>

        <button
          className={`toggle-btn ${mode === "select" ? "active" : ""}`}
          onClick={() => setMode("select")}
        >
          Choose Child
        </button>
      </div>

      {/* ---------- SELECT CHILD ---------- */}
      {mode === "select" && (
        <>
          <div className="add-child-form">
            <div className="form-row">
              <div className="form-group full-width">
                <label>Select Child</label>
                <select value={selectedChildId} onChange={handleSelectChild}>
                  <option value="">Choose your child</option>
                  {childData && childData.map((child) => (
                    <option key={child.id} value={child.id}>
                      {child.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="p-submit-button-container">
            <button className="p-submit-button" onClick={handleSubmit}>
              Add To Cart <i className="ri-shopping-cart-2-fill cart-icon"></i>
            </button>
          </div>
        </>
      )}

      {/* ---------- CREATE CHILD ---------- */}
      {mode === "create" && (
        <>
          <div className="add-child-form">
            {/* Name */}
            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="Enter first name"
                />
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Enter last name"
                />
              </div>
            </div>

            {/* Gender & DOB */}
            <div className="form-row">
              <div className="form-group">
                <label>Gender</label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select gender</option>
                  {genderList.map((g) => (
                    <option key={g.value} value={g.value}>
                      {g.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Date of Birth (MM-DD-YYYY)</label>
                <Calendar
                  placeholder="Date of Birth"
                  value={
                    formData.date_of_birth
                      ? new Date(formData.date_of_birth)
                      : null
                  }
                  onChange={handleDateChange}
                  showIcon
                  dateFormat="mm-dd-yy"
                  className="calesndr-cstm"
                  maxDate={new Date()}
                />
              </div>
            </div>

            {/* Grade & Jersey */}
            <div className="form-row">
              <div className="form-group">
                <label>Grade</label>
                <select
                  name="grade"
                  value={formData.grade}
                  onChange={handleChange}
                >
                  <option value="">Select grade</option>
                  {gradeList.map((g) => (
                    <option key={g.value} value={g.value}>
                      {g.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Jersey Size</label>
                <select
                  name="jersey_size"
                  value={formData.jersey_size}
                  onChange={handleChange}
                >
                  <option value="">Select size</option>
                  {jerseySizes.map((s) => (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* School */}
            <div className="form-row">
              <div className="form-group full-width">
                <label>School Name</label>
                <input
                  name="school_name"
                  value={formData.school_name}
                  onChange={handleChange}
                  placeholder="Enter school name"
                />
              </div>
            </div>
          </div>
          <div className="p-submit-button-container">
            <button className="p-submit-button" onClick={handleSubmit}>
              Add To Cart <i className="ri-shopping-cart-2-fill cart-icon"></i>
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default UserView;
